// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1691":"b10803c51806523f","2346":"c67d52edd94e9a5e","2611":"a28cb3c5e46a395c","4162":"6afb4761e977d574","5608":"0159f426ce270644","6793":"f57464ca23fa9330","8765":"0123e200695f05e2","9334":"e0f9d358b7e6b9d6"}[chunkId] + ".js";
};